export const AUTH_CONFIG = {
  clientId: 'PXl3AAZ10ldH6ltP7zTHsmoy0VGjCxDj',
  domain: 'galerie.eu.auth0.com',
  callbackUrl: process.env.VUE_APP_CALLBACK_URL,
  apiUrl: process.env.VUE_APP_API_ENDPOINT
}
// 'http://localhost:3000/callback'
// 'http://192.168.0.52:5000/callback'
// 'http://galerieinventory.co.uk/callback'
// 'https://galeriestock.herokuapp.com/callback'
